module.exports = __webpack_public_path__ + "static/img/shuzhiback.189223e9.png";